import React, { useEffect } from 'react';
// import RouteConstants from '../../constants/routeConstants';
import
{
    Box,
    CircularProgress,
 } from '@mui/material';
import { useState, Downgraded } from '@hookstate/core';
// import AccordianCommonRequests from '../../sharedcomponents/commonRequest/accordianCommonRequest';
import { useEventState } from '../../stores/eventStore';
// import { generatePath } from 'react-router-dom';
import Helper from '../../utility/helper';
import
{
    NO_ACCESS_PERMISSION,
    FULL_PERMISSION,
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
// import AppConstants from '../../constants/appConstants';
// import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
// import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
// import { useHistory } from 'react-router-dom';
//  import PendingActionDialog from '../../sharedcomponents/confirmationdialog/pendingActionDialog';
import DataList from '../../sharedcomponents/dataList/dataList';
import EditAllRosters from './editAllRosters';
import EditRosters from './editRosters';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};
const ManageRosters = (props) =>
{ 
    const showSearch = true;
    // const history = useHistory();
    const loading = useState(false);
    const allData = useState([]);
    const eventData = useState(null);
    const eventState = useEventState();
    const [modPermission, setModPermission] = React.useState(null);
    // const [filters, setFilters] = React.useState(null);
    // const statusList = useState(['Approved', 'Pending', 'Rejected']);
    const setAll = useState(false);
    const filteredEmty = useState(false);
    const fullData=useState([]);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    // const requestPending = useState(null);
    const userID = useState(null);
    const openNoteDialog = useState(false);
    const requestNote = useState(null);
    const filteredList = useState([]);
    const [filterChangeVal, setFilterChangeVal] = React.useState(false);
    // const [participantList, setParticipantList] = React.useState(null);
    const openAllRosterDialog = useState(false); 
    const openRosterDialog = useState(false);
    
    const eventUserInfo = useState(null);
    const editSelectedParticipant = useState(null);

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    // const pendingAction = useState({
    //     open: false,
    //     title: '',
    //     message: '',
    // });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: 5000,
        noOfPages: null,
    }); 
  
    useEffect(() =>
    {
        const eventInfo = Helper.getStorage('eventInfo');
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.eventID.value != eventInfo.eventID)
        )
        {
            eventData.set(eventInfo);
        }
      
    }, []);
    
    useEffect(() =>
    {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get())
        {
            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo))
            {
                setModPermission(FULL_PERMISSION);
                userID.set(userInfo.userID);
            } else if (userInfo.roles && Helper.isEventAdmin(userInfo))
            {
                // const permissions = eventState.permissions
                //     .attach(Downgraded)
                //     .get();
                // userID.set(userInfo.userID);
                // if (permissions && permissions.length > 0)
                // {
                //     setModPermission(
                //         Helper.getModuleAccessPermission(permissions, 'TICKET')
                //     );
                // }
                setModPermission(FULL_PERMISSION);
            }
        }
    }, [eventState]);
    useEffect(() =>
    {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION)
        {
            // const pageInfo = pagingInfo.attach(Downgraded).get();
            // if (pageInfo.itemsPerPage)
            // {
            //     getRosterManagement();
            //     getParticipantList();
            // }
            // getParticipantList();
            getRosterManagement();
        }
    }, [modPermission]);
    const getRosterManagement = () =>
    {
        loading.set(true);
        // const userInfo = Helper.getStorage('userInfo');
        // let participantList = [];
        ApiHelper.get(
            APIURLConstants.GET_ROSTER_MANAGEMENT(
                eventData.get().eventID
            )
        )
            .then((res) =>
            {
                // console.log("res",res);
                let requestData = [];
                let data = res.data.value; 
                let allRequestData = []; 
                // console.log("data",data.length,data);
                if (data.length > 0)
                {
                    data.map((item) =>
                    {
                        // console.log("item",item);                       
                        allRequestData.push({
                            actualData: item,
                            row: [
                                {
                                    label: 'checkbox',
                                    key: 'ticketID',
                                    ticketID: item.ticketID,
                                    width: '0.05',
                                    inColumn: true,
                                    alignCenter: true,
                                },
                                {
                                    label: 'Name',
                                    key: 'name',
                                    name: item.playerName,
                                    width: '0.25', 
                                    inColumn: true,
                                },

                                {
                                    label: 'Jersey No',
                                    key: 'Jersey',
                                    Jersey: item.jersey,
                                    width: '0.20',
                                    inColumn: true,
                                }, 
                                {
                                    label: 'School',
                                    key: 'school',
                                    school: item.collegeOrClub,
                                    width: '0.20',
                                    inColumn: true,
                                    alignCenter: true,
                                },
                                {
                                    label: 'Team',
                                    key: 'team',
                                    team: item.team,
                                    width: '0.15',
                                    inColumn: true,
                                    alignCenter: true,
                                }, 
                                {
                                    label: 'Position',
                                    key: 'position',
                                    position: item.positionName,
                                    width: '0.05', 
                                    inColumn: true,
                                },  
                                {
                                    label: 'Action',
                                    key: 'edit',
                                    edit: 'Edit',
                                    width: '0.10',
                                    inColumn: true,
                                    alignCenter: true,
                                },
                            ],
                            selected: false,
                        });
                    });
                    fullData.set(allRequestData) 
                } 
                // else
                // {
                //     <StyledTableRow>
                //         <StyledTableCell colSpan="7" align="center">
                //             No data found
                //         </StyledTableCell>
                //     </StyledTableRow>;
                //  }
                setShowSearchRec(false);
                let filterData = filteredList.attach(Downgraded).get();
                if (filterData.length > 0)
                {
                    setFilterChangeVal(true);
                }
                allData.set(requestData);
                loading.set(false);

                if (pagingInfo.get().noOfPages == null)
                {
                    pagingInfo.set({
                        ...pagingInfo,
                        currentPage: pagingInfo.get().currentPage,
                        itemsPerPage: pagingInfo.get().itemsPerPage,
                        noOfPages: Math.ceil(
                            res.data.totalCount / pagingInfo.get().itemsPerPage
                        ),
                    });
                }
                loading.set(false);
            })
            .catch((error) =>
            {
                loading.set(false);
                if (error.response && error.response.status === 401)
                {
                    alert(error);
                }
            });
    };
    const editAllRoster = () =>
    {   
        const selected = fullData.get().filter((user) => user.selected === true);
        if (selected.length === 0)
        {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else
        {
            editSelectedParticipant.set();
            editSelectedParticipant.set(selected);
            openAllRosterDialog.set(true);
        } 
    };
    const closeEditAllRoster = () =>
    {
        editSelectedParticipant.set(null);
        openAllRosterDialog.set(false);
    };
    const closeEditRoster = () =>
    {
        eventUserInfo.set(null);
        openRosterDialog.set(false);
    }; 

    const handleConfirmation = () =>
    {
        const gUserInfo = Helper.getStorage('userInfo');
        let deleteRequests = [];
        allData.get().map((row) =>
        {
            if (row.selected === true)
            {
                deleteRequests.push(row.actualData.ticketID);
            }
        });
        fullData.get().map((row) =>
        {
            if (row.selected === true)
            {
                deleteRequests.push(row.actualData.ticketID);
            }
        });
        ApiHelper.post(APIURLConstants.DELETE_TICKETS, {
            ticketIDs: deleteRequests.join(','),
            modifiedBy: gUserInfo.userID,
        })
            .then((res) =>
            {
                if (res.data)
                {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    setAll.set(false);
                    getRosterManagement();
                } else
                {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Something went wrong while deleting tickets',
                    });

                    setAll.set(false);
                }
            })
            .catch((error) =>
            {
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const onActionClick = (item, action) =>
    {
        let newData = [...allData.attach(Downgraded).get()];
        let index = newData.findIndex(
            (data) => data.actualData.ticketID == item.actualData.ticketID
        );
        let newItem = newData[index];

        const isStatus = action == 'Approve' ? 2 : action == 'Reject' ? 3 : 1;
        requestNote.set({
            ticketID: newItem.actualData.ticketID,
            status: isStatus,
            userID: item.actualData.userID,
            action,
            note: newItem.note,
            item: item,
        });
        openNoteDialog.set(true);
    };
    
    const filterListData = (data) =>
    {
        if (data.length == 0)
        {
            filteredEmty.set(true);
        } else
        {
            filteredEmty.set(false);
        }
        filteredList.set(data);
    };
 
     
    // const onSettingClick = () =>
    // {
    //     props.history.push({
    //         pathname: generatePath(RouteConstants.EVENT_TICKET_SETTINGS, {
    //             eventID: eventData.get().eventID,
    //         }),
    //     });
    // };
     
    const editRoster = (userInfo) =>
    {
        eventUserInfo.set(userInfo.actualData);
        openRosterDialog.set(true);
    };

    return (
        <Box sx={{ width: '100%' }}>
            {
                loading.get() ? (
                    <Box style={loader}>
                        <CircularProgress />
                    </Box>
                ) :
                modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                    <UnauthorizedUI showLogout={false} />
                ) : (
                    <DataList
                        data={fullData.attach(Downgraded).get()} 
                        editAll={editAllRoster}
                        editRow={editRoster}
                        showEdit={true}
                        hideAdd={true}
                        // handleClick={onAddRequest}
                        title={''} 
                        hideDelete={true}
                        filterChangeVal={filterChangeVal}
                        loading={loading.get()}
                        buttonTitle={'Add'}
                        showSearch={showSearch}
                        searchLabel={'Search'} 
                        // showPdfExport={true}
                        // showSettings={false}
                        // onSettingClick={onSettingClick}
                        getResults={getRosterManagement}
                        showSearchRec={showSearchRec}
                        setShowSearchRec={setShowSearchRec}
                        onActionClick={onActionClick}
                        pagingInfo={pagingInfo.attach(Downgraded).get()}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        // onPendingAction={onPendingAction}
                        modPermission={modPermission}
                        filterListData={filterListData}
                        showApproveAndReject={undefined}
                    />
                )
            }
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() =>
                    {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }         
            {openAllRosterDialog.get() && (
                <EditAllRosters
                    open={openAllRosterDialog.get()}
                    eventUserInfo={editSelectedParticipant
                        .attach(Downgraded)
                        .get()}
                    title="Edit Roasters"
                    handleClose={closeEditAllRoster}
                    snackBarProps={props.snackBarProps}
                    setSnackBarProps={props.setSnackBarProps}
                    getRosterManagement={getRosterManagement}
                />
            )}   
            {openRosterDialog.get() && (
                <EditRosters
                    open={openRosterDialog.get()}
                    eventUserInfo={eventUserInfo
                        .attach(Downgraded)
                        .get()}
                    title="Edit Roaster"
                    handleClose={closeEditRoster}
                    snackBarProps={props.snackBarProps}
                    setSnackBarProps={props.setSnackBarProps}
                    getRosterManagement={getRosterManagement}
                />
            )}  
              
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )} 
            
        </Box>
    );
};
export default ManageRosters;